import React, { memo, useMemo } from 'react'
import { useSelector } from 'react-redux'
import ReactHtmlParser from 'react-html-parser'
import { useTable } from 'react-table'
import { selectAll } from '../../../store/slices/jobTally'
import { displayFastenersAnchor, getFastenersTotal } from '../../../views/Output/utils/fastener'

const JobTally = () => {
  const jobs = useSelector(selectAll)

  const columns = useMemo(() => {
    const jobColumns = [
      {
        Header: 'Job',
        accessor: 'uid',
      },
      {
        Header: 'Model',
        accessor: 'model',
        // eslint-disable-next-line react/prop-types
        Cell: ({ value, row }) => {
          // eslint-disable-next-line react/prop-types
          const { updatedWebStiffeners, updatedSpec } = row.original
          return (
            <div className="hs__firstCell">
              <div className="hs__modelInfo">
                <span className="button__text">
                  {value}
                  {updatedWebStiffeners}
                  <br />
                  {updatedSpec}
                </span>
              </div>
            </div>
          )
        },
      },
      {
        Header: 'Quantity',
        accessor: 'quantity',
      },
      {
        Header: 'TF Fasteners',
        accessor: 'tfFastenersLabel',
        Cell: ({ value, row }) => {
          const { tfNailType } = row.original
          return displayFastenersAnchor(tfNailType, value)
        },
      },
      {
        Header: 'Face Fasteners',
        accessor: 'fFastenersLabel',
        Cell: ({ value, row }) => {
          const { hNailType } = row.original
          return displayFastenersAnchor(hNailType[0], value)
        },
      },
      {
        Header: 'Joist Fasteners',
        accessor: 'jFastenersLabel',
        Cell: ({ value, row }) => {
          const { jNailType } = row.original
          return displayFastenersAnchor(jNailType, value)
        },
      },
    ]
    return jobColumns
  }, [])

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data: jobs,
  })

  const fastenersTotal = useMemo(() => {
    const total = getFastenersTotal(jobs)
    return total
  }, [jobs])

  return (
    <div className="d-flex flex-column space-y-4 my-4">
      <div className="nonScrollable hs__nonScrollable jobTable">
        <table {...getTableProps()}>
          <thead>
            {
              // Loop over the header rows
              headerGroups.map((headerGroup) => {
                const { key, ...headerGroupProps } = headerGroup.getHeaderGroupProps()
                return (
                  // Apply the header row props
                  <tr key={key} {...headerGroupProps}>
                    {
                      // Loop over the headers in each row
                      headerGroup.headers.map((column) => {
                        const { key, ...headerProps } = column.getHeaderProps()
                        return (
                          // Apply the header cell props
                          <th key={key} {...headerProps}>
                            {column.render('Header')}
                          </th>
                        )
                      })
                    }
                  </tr>
                )
              })
            }
          </thead>
          {/* Apply the table body props */}
          <tbody {...getTableBodyProps()}>
            {
              // Loop over the table rows
              rows.map((row) => {
                // Prepare the row for display
                prepareRow(row)
                const { key, ...rowProps } = row.getRowProps()
                return (
                  // Apply the row props
                  <tr key={key} {...rowProps}>
                    {
                      // Loop over the rows cells
                      row.cells.map((cell) => {
                        // Apply the cell props
                        const { key, ...cellProps } = cell.getCellProps()
                        return (
                          <td key={key} {...cellProps}>
                            {
                              // Render the cell contents
                              cell.render('Cell')
                            }
                          </td>
                        )
                      })
                    }
                  </tr>
                )
              })
            }
          </tbody>
        </table>
        <div className="mt-4">
          <table>
            <tbody>
              <tr className="pseudoFooter">
                <td>
                  <div className="hs__subTotalHead">Fastener Totals</div>
                  <div className="hs__subTotalData" style={{ whiteSpace: 'nowrap' }}>
                    {ReactHtmlParser(fastenersTotal.join('<br />'))}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default memo(JobTally)
